var KakaoLogin = (function () {
    try {
        if (window.Kakao) {
            Kakao.init(getKey());
        }

        return {
            clickKakaoLoginButton: clickKakaoLoginButton,
        }

        function getKey() {
            if (ServerChecker.isJoins) return '37111dd82816f26314a72d9fd7bce111';
            else if (ServerChecker.isEnter) return '020b7ff29a4b65279e964a5d553b41a6';
            else if (ServerChecker.isKtworks) return KtWorksConfig.get("KAKAO_KEY");
            else if (ServerChecker.isDev) return '924c529f2b8c1e372b8526b7bb6389a2';
            else return 'd77bd9dedf121273cd1ab765d7406cb9';
        }

        function clickKakaoLoginButton() {
            var isElectron = ElectronApi.Comm.isElectron();

            if (isElectron && ElectronApi.Comm.getVersion() < "1_0_6") {
                var key = "e1d3e5b1a478fdb8e0b6b6b07f929995";
                var redirectUrl = Often.getLocOrigin() + "/login.act&response_type=code";
                var url = "https://kauth.kakao.com/oauth/authorize?client_id=" + key + "&redirect_uri=" + redirectUrl;
                Often.submitForm('kakao_login', url, "_blank", {}, {"resizable": "resizable"})
                return;
            }
            const isRenewalSignUp = !!window?.isRenewalSignUp;
            if (!isRenewalSignUp && Often.isMobile()) {
                MobileApp.goMarketOrApp({USER_ID: _USER_ID});
                return;
            }

            if (!window.Kakao) {
                Often.toast("succes", "현재 카카오 서비스 장애로 인해 로그인이 불가합니다. 조금만 기다려주세요.");
                return;
            }

            Kakao.Auth.login({
                success: kakaoAuthSuccessCallback,
                fail: function (error) {
                    console.error(error);
                }
            });



            function kakaoAuthSuccessCallback() {
                Kakao.API.request({
                    url: '/v2/user/me',
                    success: function (res) {
                        GoogleTagManager.collect({
                            event: "guest",
                            userId: res.id,
                            guestDate: Time.currentTime(),
                        });
                        const isRenewalSignUp = !!window?.isRenewalSignUp  ;
                        const profileJson = getKakaoProfileJson(res);
                        if(isRenewalSignUp && Mutil.isAct("newSignup.act")) {
                            const SignUpViewChanger = requireModule('SignUpViewChanger', {on: ['signup', 'index', 'newSignup']})();
                            SignUpViewChanger.loadSocialLoginSuccess(profileJson);
                            return;
                        }

                        CommonLogin.goLogin(profileJson);
                    },
                    fail: function (error) {
                        console.error(error);
                    }
                });
            }

            function getKakaoProfileJson(res) {
                var isProperties = (res.properties);
                return {
                    "USER_ID": res.id,
                    "ID_GB": SignCode.TYPE.KAKAO,
                    "OBJ_CNTS_NM": (isElectron ? "desktop" : ""),
                    "EMAIL": res.id,
                    "USER_NM": (isProperties ? res.properties.nickname : res.id),
                    "PRFL_PHTG": (isProperties ? res.properties.thumbnail_image : ""),
                };
            }
        }
    } catch (e) {
        console.error(e);
    }
})()
